module.exports = __webpack_public_path__ + "static/media/galerija_2021 (5).3b4d5f47.jpg";